import { DateTime } from 'luxon'

import { Ride } from '@types'

export const displayElapsedTimeFromRide = (ride: Ride): string | undefined => {
  if (!ride.end_time) {
    return undefined
  }

  const startTime = DateTime.fromISO(ride.start_time)
  const endTime = DateTime.fromISO(ride.end_time)
  const duration = endTime.diff(startTime, ['minutes', 'seconds'])
  return duration.toFormat('m:ss')
}
